var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "margin-bottom": "-80px"
    }
  }, [_c('v-img', {
    staticClass: "clea-mask1 mx-auto",
    attrs: {
      "src": require("@/assets/claire_wed.jpg"),
      "aspect-ratio": "1.0852",
      "max-width": "384",
      "contain": ""
    },
    on: {
      "click": _vm.onCleaClick
    }
  }, [_c('div', {
    staticClass: "clea-overlay clea-mask2"
  })]), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }]
  }, [_c('div', {
    staticClass: "py-4 text-center"
  }, [_c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.summon(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Summon')))]), _c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.summon(10);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Summon 10 Times')))])], 1), _c('v-slide-y-transition', {
    attrs: {
      "group": ""
    }
  }, [_vm._l(_vm.summons.slice().reverse(), function (summon) {
    return [_c('v-card', {
      key: "home-summon-".concat(summon.id),
      staticClass: "ma-4"
    }, [_c('div', {
      staticClass: "pa-1"
    }, [_c('div', {
      staticClass: "d-flex justify-center"
    }, [_vm._l(summon.characterIDs.slice(0, 5), function (characterID) {
      return [_c('router-link', {
        attrs: {
          "to": "/character/".concat(characterID)
        }
      }, [_c('CharaIcon', {
        staticClass: "ma-1",
        attrs: {
          "id": characterID,
          "size": _vm.$size(),
          "frame": true
        }
      })], 1)];
    })], 2), _c('div', {
      staticClass: "d-flex justify-center"
    }, [_vm._l(summon.characterIDs.slice(5, 10), function (characterID) {
      return [_c('router-link', {
        attrs: {
          "to": "/character/".concat(characterID)
        }
      }, [_c('CharaIcon', {
        staticClass: "ma-1",
        attrs: {
          "id": characterID,
          "size": _vm.$size(),
          "frame": true
        }
      })], 1)];
    })], 2)]), _c('div', {
      staticClass: "text-center primary--text pb-2",
      domProps: {
        "innerHTML": _vm._s(_vm.$t("Summon Text.".concat(summon.maxRare < 4 ? 'Failure' : 'Success')))
      }
    })])];
  })], 2), _c('v-divider')], 1)]), _c('div', {
    staticClass: "my-6 text-center"
  }, [_c('p', {
    staticClass: "display-1 primary--text mb-2"
  }, [_vm._v(_vm._s(_vm.$t('KiraFan.Moe')))]), _c('p', {
    staticClass: "title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('KiraFan Wiki')))])]), _c('QuickJump'), _c('Media'), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "text-center",
    class: _vm.$s.isHomePageFooterFixed ? 'margin-footer' : ''
  }, [_vm._v(_vm._s(_vm.$t('Day Count').format(_vm.dayCount)))]), _c('v-bottom-navigation', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "fixed": _vm.$s.isHomePageFooterFixed
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/characters"
    }
  }, [_vm._v(_vm._s(_vm.$t('Character'))), _c('v-icon', [_vm._v("mdi-cards")])], 1), _c('v-btn', {
    attrs: {
      "to": "/weapons"
    }
  }, [_vm._v(_vm._s(_vm.$t('Weapons'))), _c('v-icon', [_vm._v("mdi-sword")])], 1), _c('v-btn', {
    attrs: {
      "to": "/questlibraries"
    }
  }, [_vm._v(_vm._s(_vm.$t('Quests'))), _c('v-icon', [_vm._v("mdi-sword-cross")])], 1), _c('v-btn', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v(_vm._s(_vm.$t('Settings'))), _c('v-icon', [_vm._v("mdi-cog")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }